export default class ProjetoListController {
  constructor($state, Group, UIService, Projeto, ProjetoService, EntidadeFinanciadora, Papel, ProjetoEstado, ProjetoEstadoCandidatura, Investigador, User, AreaInterdisciplinar, Instituicao, GrupoInvestigacao) {
    this.$state = $state;
    this.Group = Group;
    this.UI = UIService;
    this.Projeto = Projeto;
    this.ProjetoService = ProjetoService;
    this.EntidadeFinanciadora = EntidadeFinanciadora;
    this.Papel = Papel;
    this.ProjetoEstado = ProjetoEstado;
    this.ProjetoEstadoCandidatura = ProjetoEstadoCandidatura;
    this.Investigador = Investigador;
    this.User = User;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.Instituicao = Instituicao;
    this.GrupoInvestigacao = GrupoInvestigacao;

    this.dataLoaded = false;

    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.entidadesFinanciadoras = [];
    this.papeis = [];
    this.estados = [];
    this.estadosCandidatura = [];
    this.investigadores = [];
    this.users = [];
    this.areas = [];
    this.instituicoes = [];
    this.gruposInvestigacao = [];
    this.filtersLoaded = [1, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    this.opt = $state.params;

    this.displayColumns = [
      { displayName: 'ID SGI', name: 'id', visible: false, sortable: true },
      { displayName: 'Acrónimo', name: 'acronimo', visible: true, sortable: true },
      { displayName: 'Slug', name: 'slug', visible: false, sortable: true },
      { displayName: 'Título', name: 'titulo', visible: false, sortable: true },
      { displayName: 'Data de Candidatura', name: 'dataCandidatura', exportDate: 'DD-MM-YYYY', sortable: true, visible: false },
      { displayName: 'Data Comunicação Avaliação', name: 'dataComunicacaoAvaliacao', exportDate: 'DD-MM-YYYY', sortable: true, visible: false },
      { displayName: 'Data de Início', name: 'dataInicio', exportDate: 'DD-MM-YYYY', sortable: true, visible: true },
      { displayName: 'Data de Fim', name: 'dataFim', exportDate: 'DD-MM-YYYY', sortable: true, visible: true },
      { displayName: 'Entidade Financiadora', name: 'entidadeFinanciadora', visible: true, sortable: true },
      { displayName: 'Código de Financiamento', name: 'codigoFinanciamento', visible: false, sortable: true },
      { displayName: 'Papel', name: 'papel', visible: true, sortable: true },
      { displayName: 'Estado', name: 'estado', visible: true, sortable: true },
      { displayName: 'Estado de Candidatura', name: 'estadoCandidatura', visible: false, sortable: true },
      { displayName: 'WWW', name: 'www', visible: false, sortable: true },
      { displayName: 'Investigador Principal', name: 'investigador', visible: true, sortable: true },
      { displayName: 'Co-Investigador Principal', name: 'coInvestigador', visible: false, sortable: true },
      { displayName: 'Commercial Adoptions', name: 'commercialAdoptions', visible: false, sortable: true },
      { displayName: 'Different Institutions Authors', name: 'differentInstitutionsAuthors', visible: false, sortable: true },
      { displayName: 'Relevant Stakeholders as partners', name: 'relevantStakeholders', visible: false, sortable: true },
      { displayName: 'Citizen science approach', name: 'citizenScienceApproach', visible: false, sortable: true },
      { displayName: 'Performed public consultation', name: 'performedPublicConsultation', visible: false, sortable: true },
      { displayName: 'Educational resource deliverable', name: 'resourceDeliverable', visible: false, sortable: true },
      { displayName: 'International collaboration', name: 'internationalCollaboration', visible: false, sortable: true },
      { displayName: 'Researchers developing countries', name: 'developingCountries', visible: false, sortable: true },
      { displayName: 'Criado Por', name: 'criadoPor', visible: false, sortable: true },
      { displayName: 'Pub. Frontend', name: 'publicado', visible: true, sortable: true }
    ];

    // type 's': select, 'o': plain text, 'd': date
    this.equalityFilters = [{
      val: 'a',
      name: 'Igual',
      type: 'o'
    },
      {
        val: 'b',
        name: 'Diferente',
        type: 'o'
      },
      {
        val: 'c',
        name: 'Começa por',
        type: 'o'
      },
      {
        val: 'd',
        name: 'Termina com',
        type: 'o'
      },
      {
        val: 'e',
        name: 'Contém',
        type: 'o'
      },
      {
        val: 'a',
        name: 'Igual (=)',
        type: 'd'
      },
      {
        val: 'b',
        name: 'Diferente de (≠)',
        type: 'd'
      },
      {
        val: 'c',
        name: 'Posterior a (>)',
        type: 'd'
      },
      {
        val: 'd',
        name: 'Anterior a (<)',
        type: 'd'
      },
      {
        val: 'e',
        name: 'Posterior ou igual (≥)',
        type: 'd'
      },
      {
        val: 'f',
        name: 'Anterior ou igual (≤)',
        type: 'd'
      },
      {
        val: 'a',
        name: 'Igual',
        type: 's'
      },
      {
        val: 'b',
        name: 'Diferente',
        type: 's'
      }
    ];

    this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');

    this.columns = [{
      id: 'Projeto.id',
      name: 'ID SGI',
      type: 'o'
    },
    {
      id: 'Projeto.acronimo',
      name: 'Acrónimo',
      type: 'o'
    },
    {
      id: 'Projeto.slug',
      name: 'Slug',
      type: 'o'
    },
    {
      id: 'Projeto.titulo',
      name: 'Título',
      type: 'o'
    },
    {
      id: 'Projeto.dataCandidatura',
      name: 'Data de Candidatura',
      type: 'd',
      format: "YYYY-MM-DD",
      displayFormat: "DD/MM/YYYY"
    },
    {
      id: 'Projeto.dataComunicacaoAvaliacao',
      name: 'Data Comunicação Avaliação',
      type: 'd',
      format: "YYYY-MM-DD",
      displayFormat: "DD/MM/YYYY"
    },
    {
      id: 'Projeto.dataInicio',
      name: 'Data de Início',
      type: 'd',
      format: "YYYY-MM-DD",
      displayFormat: "DD/MM/YYYY"
    },
    {
      id: 'Projeto.dataFim',
      name: 'Data de Fim',
      type: 'd',
      format: "YYYY-MM-DD",
      displayFormat: "DD/MM/YYYY"
    },
    {
      id: 'Projeto.entidadeFinanciadoraId',
      name: 'Entidade Financiadora',
      type: 's',
      list: this.entidadesFinanciadoras
    },
    {
      id: 'Projeto.codigoFinanciamento',
      name: 'Código Financiamento',
      type: 'o'
    },
    {
      id: 'Projeto.papelId',
      name: 'Papel',
      type: 's',
      list: this.papeis
    },
    {
      id: 'Projeto.estadoId',
      name: 'Estado',
      type: 's',
      list: this.estados
    },
    {
      id: 'Projeto.estadoCandidaturaId',
      name: 'Estado de Candidatura',
      type: 's',
      list: this.estadosCandidatura
    },
    {
      id: 'Projeto.www',
      name: 'Endereço Web',
      type: 'o'
    },
    {
      id: 'Projeto.investigadorId',
      name: 'Investigador Principal',
      type: 's',
      list: this.investigadores
    },
    {
      id: 'Projeto.coInvestigadorId',
      name: 'Co-Investigador Principal',
      type: 's',
      list: this.investigadores
    },
    {
      id: 'ProjetoEquipa.investigadorId',
      name: 'Membro da Equipa',
      type: 's',
      list: this.investigadores
    },
    {
      id: 'ProjetoAreaInterdisciplinar.areaId',
      name: 'Área Interdisciplinar',
      type: 's',
      list: this.areas
    },
    {
      id: 'ProjetoInstituicao.instituicaoId',
      name: 'Instituição',
      type: 's',
      list: this.instituicoes
    },
    {
      id: 'ProjetoGrupoInvestigacao.grupoInvestigacaoId',
      name: 'Grupo Investigação',
      type: 's',
      list: this.gruposInvestigacao
    },
    {
      id: 'Projeto.emDestaque',
      name: 'Em Destaque',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.commercialAdoptions',
      name: 'Commercial Adoptions',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.differentInstitutionsAuthors',
      name: 'Different Institutions Authors',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.relevantStakeholders',
      name: 'Relevant Stakeholders as partners',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.citizenScienceApproach',
      name: 'Citizen science approach',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.performedPublicConsultation',
      name: 'Performed public consultation',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.resourceDeliverable',
      name: 'Educational resource deliverable',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.internationalCollaboration',
      name: 'International collaboration',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.developingCountries',
      name: 'Researchers developing countries',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Projeto.criadoPorId',
      name: 'Criado por',
      type: 's',
      list: this.users
    },
    {
      id: 'Projeto.publicado',
      name: 'Publicado Frontend',
      type: 's',
      list: this.simnao
    }
    ];


    // Find relevant displayColumns from local storage
    if (localStorage.getItem('ISR_SGI_DisplayColumns')) {
      let displayColumns = JSON.parse(localStorage.getItem('ISR_SGI_DisplayColumns'));
      if (displayColumns && displayColumns.projeto && displayColumns.projeto.length > 0) {
        displayColumns.projeto.forEach(c => {
          let i = this.displayColumns.findIndex(x => x.name === c.name);
          if (i >= 0) this.displayColumns[i].visible = c.visible;
        });
      }
    }

    this.customFilters = [];

    // Find customFilters from local storage
    if (localStorage.getItem('ISR_SGI_Filters')) {
      let storageFilters = JSON.parse(localStorage.getItem('ISR_SGI_Filters'));
      if (storageFilters.projeto) this.customFilters = storageFilters.projeto;
    }

    // Check if something comes from the URL, replace the customFilters if so
    if (this.opt.filter) {
      this.customFilters = [];
      let filters = this.opt.filter.split(":");
      filters.forEach(filter => {
        let a = filter.split("·");
        if (a.length === 3) {
          try {
            let data = {
              column: {},
              value: {}
            };
            data.column.selected = this.columns.find(f => {
              return f.id === a[0];
            });
            if (angular.isUndefined(data.column.selected)) {
              throw Error();
            }
            this.customFilters.push(data);
          } catch (e) {
            this.customFilters = [];
            this.UI.addToast('Não foi possível carregar filtros');
          }
        }
      });
      // If updated, save it to local storage
      this.setToLocalStorage('ISR_SGI_Filters', 'projeto', this.customFilters);
    }

    // Restore list to selected if exists
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column && f.column.selected) {
          if (f.column.selected.id === 'Projeto.entidadeFinanciadoraId')
            f.column.selected.list = this.entidadesFinanciadoras;
          if (f.column.selected.id === 'Projeto.papelId')
            f.column.selected.list = this.papeis;
          if (f.column.selected.id === 'Projeto.estadoId')
            f.column.selected.list = this.estados;
          if (f.column.selected.id === 'Projeto.estadoCandidaturaId')
            f.column.selected.list = this.estadosCandidatura;
          if (f.column.selected.id === 'Projeto.investigadorId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'Projeto.coInvestigadorId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'ProjetoEquipa.investigadorId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'ProjetoAreaInterdisciplinar.areaId')
            f.column.selected.list = this.areas;
          if (f.column.selected.id === 'ProjetoInstituicao.instituicaoId')
            f.column.selected.list = this.instituicoes;
          if (f.column.selected.id === 'ProjetoGrupoInvestigacao.grupoInvestigacaoId')
            f.column.selected.list = this.gruposInvestigacao;
          if (f.column.selected.id === 'Projeto.emDestaque')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.commercialAdoptions')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.differentInstitutionsAuthors')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.relevantStakeholders')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.citizenScienceApproach')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.performedPublicConsultation')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.resourceDeliverable')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.internationalCollaboration')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.developingCountries')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Projeto.criadoPorId')
            f.column.selected.list = this.users;
          if (f.column.selected.id === 'Projeto.publicado')
            f.column.selected.list = this.simnao;
        }
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    // Number of selected items
    this.nSelected = 0;
    this.everythingSelected = false;

    // Load the data for the filter panel (not mandatory just to look at the table)
    this.loadData();
    // Load the table data so we can see stuff even if nothing else works
    this.getProjetos();
  }

  // Set to localStorage storageKey, to the value with the content for that value
  setToLocalStorage = (storageKey, value, content) => {
    let s = JSON.parse(localStorage.getItem(storageKey));
    if (s) { // If storageKey exists, check if value exists
      if (s[value]) {
        if (content) {
          s[value] = content;
        } else {
          delete s[value];
        }
      } else {
        if (content) {
          s[value] = content;
        } else {
          // Nothing...
        }
      }
    } else {
      if (content) {
        s = {};
        s[value] = content;
      } else {
        // Nothing...
      }
    }
    localStorage.setItem(storageKey, JSON.stringify(s));
  };



  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({
        key: data.key,
        value: data.value
      });
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({
          key: data.key,
          value: whereObject[data.key]
        });
        delete whereObject[data.key];
        whereOrObject.push({
          key: data.key,
          value: data.value
        });
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };

  clearFilter = () => {
    this.setToLocalStorage('ISR_SGI_Filters', 'projeto', null);
    this.customFilters = [];
    this.getProjetos();
  };

  getProjetos = () => {
    this.tableLoading = true;

    let whereFields = this.setWhereFields(this.customFilters);

    this.Projeto.table({
      params: {
        fields: [ // edit exportProjetos() too
          'Projeto.id as id',
          'Projeto.acronimo as acronimo',
          'Projeto.slug as slug',
          'Projeto.titulo as titulo',
          'Projeto.dataCandidatura as dataCandidatura',
          'Projeto.dataComunicacaoAvaliacao as dataComunicacaoAvaliacao',
          'Projeto.dataInicio as dataInicio',
          'Projeto.dataFim as dataFim',
          'Projeto.codigoFinanciamento as codigoFinanciamento',
          'Projeto.www as www',
          'Projeto.emDestaque as emDestaque',
          'Projeto.commercialAdoptions as commercialAdoptions',
          'Projeto.differentInstitutionsAuthors as differentInstitutionsAuthors',
          'Projeto.relevantStakeholders as relevantStakeholders',
          'Projeto.citizenScienceApproach as citizenScienceApproach',
          'Projeto.performedPublicConsultation as performedPublicConsultation',
          'Projeto.resourceDeliverable as resourceDeliverable',
          'Projeto.internationalCollaboration as internationalCollaboration',
          'Projeto.developingCountries as developingCountries',
          'Projeto.criadoPorId as criadoPorId',
          'Projeto.publicado as publicado',
          'EntidadeFinanciadora.designacao as entidadeFinanciadora',
          'Papel.designacao as papel',
          'ProjetoEstado.designacao as estado',
          'ProjetoEstadoCandidatura.designacao as estadoCandidatura',
          'Investigador.id as investigadorId',
          'Investigador.nome as investigador',
          'Investigador2.id as coInvestigadorId',
          'Investigador2.nome as coInvestigador',
          'User.name as criadoPor'
        ],
        from: ['Projeto', 'EntidadeFinanciadora', 'Papel', 'ProjetoEstado', 'ProjetoEstadoCandidatura', 'Investigador', 'Investigador', 'User', 'ProjetoEquipa', 'ProjetoAreaInterdisciplinar', 'ProjetoInstituicao', 'ProjetoGrupoInvestigacao'],
        referencesOrigin: [undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 'ProjetoEquipa.projetoId', 'ProjetoAreaInterdisciplinar.projetoId', 'ProjetoInstituicao.projetoId', 'ProjetoGrupoInvestigacao.projetoId'],
        references: [undefined, 'Projeto.entidadeFinanciadoraId', 'Projeto.papelId', 'Projeto.estadoId', 'Projeto.estadoCandidaturaId', 'Projeto.investigadorId', 'Projeto.coInvestigadorId', 'Projeto.criadoPorId', 'Projeto.id', 'Projeto.id', 'Projeto.id', 'Projeto.id'],
        aliases: [null, null, null, null, null, null, 'Investigador2', null, null, null, null, null],
        where: whereFields.where,
        whereLiteral: whereFields.whereLiteral,
        whereDates: whereFields.whereDates,
        whereOr: whereFields.whereOr,
        whereOrLiteral: whereFields.whereOrLiteral,
        groupBy: ['Projeto.id'], // Do groupBy when having N:M relation
        order: this.opt.order,
        sort: this.opt.sort,
        limit: this.opt.items,
        skip: (this.opt.page - 1) * this.opt.items,
      }
    }).$promise.then(res => {
      let page = this.opt.page;
      let items = this.opt.items;

      let total = res.count;

      this.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.start - 1 + items) >= total) {
        this.end = total;
      } else {
        this.end = Number.parseInt(this.start - 1 + items);
      }

      // Process output
      res.data.forEach(i => {

      });

      this.projetos = res.data;
      this.total = total;
      this.tableLoading = false;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na busca de projetos. Verifique a ligação");
    });
  };

  isColumnVisible = (column) => {
    let f = this.displayColumns.find(x => x.name === column);
    return _.isEmpty(f) ? false : f.visible;
  };

  selectVisibleColumns = () => {
    let options = {
      size: 'md',
      template: require('./columns.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = "Editar Campos Visíveis";
        scope.displayColumns = angular.copy(this.displayColumns);

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then((res) => {
      if (res && res.displayColumns) {
        this.displayColumns = angular.copy(res.displayColumns);
        // Save it to local storage
        this.setToLocalStorage('ISR_SGI_DisplayColumns', 'projeto', this.displayColumns);
      }
    });
  };

  loadData = () => {
    this.EntidadeFinanciadora.find({
    }).$promise.then(entidadesFinanciadoras => {
      entidadesFinanciadoras.forEach(t => {
        t.name = t.designacao;
      });
      this.entidadesFinanciadoras = entidadesFinanciadoras;
      this.filtersLoaded[1] = 1;
    }).catch(e => {
      this.entidadesFinanciadoras = [];
      this.filtersLoaded[1] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Entidades Financiadoras).");
    });

    this.Papel.find({
    }).$promise.then(papeis => {
      papeis.forEach(t => {
        t.name = t.designacao;
      });
      this.papeis = papeis;
      this.filtersLoaded[2] = 1;
    }).catch(e => {
      this.papeis = [];
      this.filtersLoaded[2] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Papéis).");
    });

    this.ProjetoEstado.find({
    }).$promise.then(estados => {
      estados.forEach(t => {
        t.name = t.designacao;
      });
      this.estados = estados;
      this.filtersLoaded[3] = 1;
    }).catch(e => {
      this.estados = [];
      this.filtersLoaded[3] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Estados).");
    });

    this.ProjetoEstadoCandidatura.find({
    }).$promise.then(estadosCandidatura => {
      estadosCandidatura.forEach(t => {
        t.name = t.designacao;
      });
      this.estadosCandidatura = estadosCandidatura;
      this.filtersLoaded[4] = 1;
    }).catch(e => {
      this.estadosCandidatura = [];
      this.filtersLoaded[4] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Estados de Candidatura).");
    });

    this.Investigador.find({
    }).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      investigadores.forEach(t => {
        t.name = t.nome;
      });
      this.investigadores = investigadores;
      this.filtersLoaded[5] = 1;
    }).catch(e => {
      this.investigadores = [];
      this.filtersLoaded[5] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Investigadores).");
    });

    this.User.find({
      filter: {
        where: {
          email: {like: '%isr.uc.pt'} // Only show @ISR users
        }
      }
    }).$promise.then(users => {
      // users.forEach(t => {
      //   t.name = t.designacao;
      // });
      this.users = users;
      this.filtersLoaded[6] = 1;
    }).catch(e => {
      this.users = [];
      this.filtersLoaded[6] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Utilizadores).");
    });

    this.AreaInterdisciplinar.find({
    }).$promise.then(areas => {
      areas.forEach(t => {
        t.name = t.designacao;
      });
      this.areas = areas;
      this.filtersLoaded[7] = 1;
    }).catch(e => {
      this.areas = [];
      this.filtersLoaded[7] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Áreas Interdisciplinares).");
    });

    this.Instituicao.find({
    }).$promise.then(instituicoes => {
      instituicoes.forEach(t => {
        t.name = t.designacao;
      });
      this.instituicoes = instituicoes;
      this.filtersLoaded[8] = 1;
    }).catch(e => {
      this.instituicoes = [];
      this.filtersLoaded[8] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Instituições).");
    });

    this.GrupoInvestigacao.find({
    }).$promise.then(gruposInvestigacao => {
      gruposInvestigacao.forEach(t => {
        t.name = t.designacao;
      });
      this.gruposInvestigacao = gruposInvestigacao;
      this.filtersLoaded[9] = 1;
    }).catch(e => {
      this.gruposInvestigacao = [];
      this.filtersLoaded[9] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Grupos Investigação).");
    });
  };

  sort = key => {
    if (!key.sortable) {
      return;
    }
    let keyname = key.name;
    if (this.opt.order === keyname)
      this.opt.page = 1;
    this.opt.order = keyname;
    this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
    this.$state.go('app.projeto.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getProjetos();
  };

  item = val => {
    this.opt.items = val;
    this.$state.go('app.projeto.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getProjetos();
  };

  page = sum => {
    this.opt.page += sum;
    if (this.opt.page < 1)
      this.opt.page = 1;
    if (this.opt.page > Math.ceil(this.total / this.opt.items))
      this.opt.page = Math.ceil(this.total / this.opt.items);
    this.$state.go('app.projeto.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getProjetos();
  };

  openFilter = () => {
    let result = this.filtersLoaded.reduce((a, b) => a + b, 0);

    if (result !== this.filtersLoaded.length) {
      this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
      return;
    }

    if (!this.entidadesFinanciadoras.length && !this.papeis.length && !this.investigadores.length
      && !this.estados.length && !this.users.length && !this.areas.length && !this.instituicoes.length) {
      this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
      return;
    }

    this.columns.forEach(f => {
      if (f.id === 'Projeto.entidadeFinanciadoraId')
        f.list = this.entidadesFinanciadoras;
      if (f.id === 'Projeto.papelId')
        f.list = this.papeis;
      if (f.id === 'Projeto.estadoId')
        f.list = this.estados;
      if (f.id === 'Projeto.estadoCandidaturaId')
        f.list = this.estadosCandidatura;
      if (f.id === 'Projeto.investigadorId')
        f.list = this.investigadores;
      if (f.id === 'Projeto.coInvestigadorId')
        f.list = this.investigadores;
      if (f.id === 'ProjetoEquipa.investigadorId')
        f.list = this.investigadores;
      if (f.id === 'ProjetoAreaInterdisciplinar.areaId')
        f.list = this.areas;
      if (f.id === 'ProjetoInstituicao.instituicaoId')
        f.list = this.instituicoes;
      if (f.id === 'ProjetoGrupoInvestigacao.grupoInvestigacaoId')
        f.list = this.gruposInvestigacao;
      if (f.id === 'Projeto.emDestaque')
        f.list = this.simnao;
      if (f.id === 'Projeto.commercialAdoptions')
        f.list = this.simnao;
      if (f.id === 'Projeto.differentInstitutionsAuthors')
        f.list = this.simnao;
      if (f.id === 'Projeto.relevantStakeholders')
        f.list = this.simnao;
      if (f.id === 'Projeto.citizenScienceApproach')
        f.list = this.simnao;
      if (f.id === 'Projeto.performedPublicConsultation')
        f.list = this.simnao;
      if (f.id === 'Projeto.resourceDeliverable')
        f.list = this.simnao;
      if (f.id === 'Projeto.internationalCollaboration')
        f.list = this.simnao;
      if (f.id === 'Projeto.developingCountries')
        f.list = this.simnao;
      if (f.id === 'Projeto.criadoPorId')
        f.list = this.users;
      if (f.id === 'Projeto.publicado')
        f.list = this.simnao;
    });

    // Copy column to be used in
    this.editColumns = angular.copy(this.columns);

    // Restore list to selected
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column.selected.id === 'Projeto.entidadeFinanciadoraId')
          f.column.selected.list = this.entidadesFinanciadoras;
        if (f.column.selected.id === 'Projeto.papelId')
          f.column.selected.list = this.papeis;
        if (f.column.selected.id === 'Projeto.estadoId')
          f.column.selected.list = this.estados;
        if (f.column.selected.id === 'Projeto.estadoCandidaturaId')
          f.column.selected.list = this.estadosCandidatura;
        if (f.column.selected.id === 'Projeto.investigadorId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'Projeto.coInvestigadorId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'ProjetoEquipa.investigadorId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'ProjetoAreaInterdisciplinar.areaId')
          f.column.selected.list = this.areas;
        if (f.column.selected.id === 'ProjetoInstituicao.instituicaoId')
          f.column.selected.list = this.instituicoes;
        if (f.column.selected.id === 'ProjetoGrupoInvestigacao.grupoInvestigacaoId')
          f.column.selected.list = this.gruposInvestigacao;
        if (f.column.selected.id === 'Projeto.emDestaque')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.commercialAdoptions')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.differentInstitutionsAuthors')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.relevantStakeholders')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.citizenScienceApproach')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.performedPublicConsultation')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.resourceDeliverable')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.internationalCollaboration')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.developingCountries')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Projeto.criadoPorId')
          f.column.selected.list = this.users;
        if (f.column.selected.id === 'Projeto.publicado')
          f.column.selected.list = this.simnao;
      }
    });
    // Copy customFilter to another variable so we can edit it all we want
    this.editCustomFilters = angular.copy(this.customFilters);
    // Show side panel
    this.fs = true;
  };

  oldColumn = ($item, i) => {
    //Infinite Scroll Magic
    i.infiniteScroll = {};
    i.infiniteScroll.numToAdd = 20;
    i.infiniteScroll.currentItems = 20;

    if ($item.type === 's')
      i.value = {};
    else
      i.value = "";

    i.addMoreItems = function () {
      i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
    };
  };

  applyFilter = () => {
    // Parse values from sidebar
    this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));

    // Remove list for column, no need to save it
    this.editCustomFilters.forEach(f => {
      if (f.column && f.column.selected) {
        f.column.selected.list = [];
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    this.customFilters = angular.copy(this.editCustomFilters);

    this.setToLocalStorage('ISR_SGI_Filters', 'projeto', this.customFilters);
    this.fs = false;
    // Go to first page for results
    this.opt.page = 1;
    this.$state.go('app.projeto.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });

    this.getProjetos();
  };

  hasSelect = () => {
    return _.some(this.projetos, a => a.selected === true);
  };

  selectAll = () => {
    if (this.allSelected) { // Not all are selected, select all
      this.projetos.forEach(a => {
        a.selected = true;
      });
      this.nSelected = this.projetos.length;
    } else { // Remove all selections
      this.projetos.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
    }
    this.everythingSelected = false;
  };

  selectEverything = (type) => {
    if (!type) {
      this.projetos.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
      this.allSelected = false;
    }
    this.everythingSelected = !!type;
  };

  selectItem = () => {
    this.nSelected = _.filter(this.projetos, r => r.selected).length;
    this.allSelected = this.nSelected >= this.projetos.length;
    this.everythingSelected = false;
  };

  deleteProjeto = (projeto) => {
    this.ProjetoService.confirmDeleteProjeto(projeto).then(() => {
      this.getProjetos();
    }).catch(error => {
      console.log(error);
      this.getProjetos();
    });
  };
}

ProjetoListController.$inject = ['$state', 'Group', 'UIService', 'Projeto', 'ProjetoService', 'EntidadeFinanciadora', 'Papel', 'ProjetoEstado', 'ProjetoEstadoCandidatura', 'Investigador', 'User', 'AreaInterdisciplinar', 'Instituicao', 'GrupoInvestigacao'];
